import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";

import { doctorsApi } from "../../services/api/doctors.api";
import { TimeSlot } from "../../types/availability.definition";
import {
  getAvailabilitiesFailure,
  getAvailabilitiesInRangeRequest,
  getAvailabilitiesRequest,
  getAvailabilitiesSuccess,
} from "../reducers/availabilitiesSlice";

export function* getAvailabilitiesSaga({
  payload,
}: PayloadAction<{ id: string }>) {
  try {
    const doctorId = parseInt(payload.id, 10);
    const response: TimeSlot[] = yield call(
      doctorsApi.getAvailableTimeSlots,
      doctorId
    );
    yield put(getAvailabilitiesSuccess(response));
  } catch (error) {
    // Just update the availabilities reducer state
    const errorMessage =
      error instanceof Error ? error.message : "Failed to load availabilities";
    yield put(getAvailabilitiesFailure(errorMessage));
  }
}

export function* getAvailabilitiesInRangeSaga({
  payload,
}: PayloadAction<{ id: string; startDate?: string; endDate?: string }>) {
  try {
    const doctorId = parseInt(payload.id, 10);

    let response: TimeSlot[];
    if (payload.startDate) {
      // Use getAllTimeSlotsByDateRange with startDate (endDate is optional)
      response = yield call(
        doctorsApi.getAllTimeSlotsByDateRange,
        doctorId,
        payload.startDate,
        payload.endDate || null
      );
    } else {
      // Fallback to getAvailableTimeSlots if no startDate provided
      response = yield call(doctorsApi.getAvailableTimeSlots, doctorId);
    }

    yield put(getAvailabilitiesSuccess(response));
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Failed to load availabilities";
    yield put(getAvailabilitiesFailure(errorMessage));
  }
}

export function* watchAvailabilities() {
  yield takeLatest(getAvailabilitiesRequest.type, getAvailabilitiesSaga);
  yield takeLatest(
    getAvailabilitiesInRangeRequest.type,
    getAvailabilitiesInRangeSaga
  );
}
